import {Link, useLocation} from "react-router-dom";
import {Routes as R} from "../utils";


export default function Header(props) {
  const location = useLocation()


  const Element = ({link, label}) => {
    const active = location.pathname === link
    return (
      <li className="nav-item">
        <Link to={link}>
          <button className={`nav-link ${active && 'active'}`}>
            {label}
          </button>
        </Link>
      </li>
    )
  }

  return (
    <header className="d-flex justify-content-center py-3">
      <ul className="nav nav-pills">
        <Element link={R.home} label="Start"/>
        <Element link={R.configuration} label="Konfiguracja"/>
        <Element link={R.view} label="Widok"/>
        <Element link={R.customer} label="Dane klienta"/>
        <Element link={R.summary} label="Podsumowanie"/>
      </ul>
    </header>
  )
}
